/**
 * <TutorHomeSkeleton> — la forme de l'accueil du masteur pendant son premier chargement.
 *
 * Le cas courant : un masteur installé, un jour de lives (deux), une offre qui attend, deux choses
 * à faire, son score et son mois. Le salut s'écrit si le prénom est connu ; les sections gardent
 * leurs vrais intitulés ; chaque forme vient de son composant (`<TutorTodaySectionSkeleton>`,
 * `<TutorScoreCardSkeleton>`, `<TutorEarningsCardSkeleton>`…), et la disposition de
 * `<TutorHomeColumns>` : le squelette bascule au même seuil que la page.
 */
import React from "react"

import { Stack } from "../../atoms/containers/Stack"
import { List } from "../../molecules/List"
import { TutorEarningsCardSkeleton } from "../../organisms/TutorEarningsCard"
import { TutorScoreCardSkeleton } from "../../organisms/TutorScoreCard"
import { TutorTodaySectionSkeleton } from "../../templates/TutorTodaySection"
import { TutorHomeColumns } from "./TutorHomeColumns"
import { TutorHomeGreetingSkeleton } from "./TutorHomeGreeting"
import { TutorHomeOfferSkeleton } from "./TutorHomeOffer"
import { TutorHomeTodoSkeleton } from "./TutorHomeTodo"

export function TutorHomeSkeleton(props: { firstname?: string }) {
    return (
        <Stack gap="6">
            <TutorHomeGreetingSkeleton firstname={props.firstname} />
            <TutorHomeColumns
                today={<TutorTodaySectionSkeleton />}
                offer={<TutorHomeOfferSkeleton />}
                todo={<TutorHomeTodoSkeleton />}
                score={
                    <List title="Mon score">
                        <TutorScoreCardSkeleton />
                    </List>
                }
                month={<TutorEarningsCardSkeleton />}
            />
        </Stack>
    )
}
